import { render } from "./BulkGenerate.vue?vue&type=template&id=16570bce&scoped=true"
import script from "./BulkGenerate.vue?vue&type=script&lang=js"
export * from "./BulkGenerate.vue?vue&type=script&lang=js"

import "./BulkGenerate.vue?vue&type=style&index=0&id=16570bce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16570bce"]])

export default __exports__